module.exports = __webpack_public_path__ + "static/media/Folkul.79c7c0a0.png";